// extracted by mini-css-extract-plugin
module.exports = {"active":"top-nav_active__3WqwX","link":"top-nav_link__cSCA4"};